// extracted by mini-css-extract-plugin
export var acitonButtons = "_hu-0";
export var additionalIcon = "_hu-f";
export var block = "_hu-1";
export var blockContent = "_hu-7";
export var blockDescription = "_hu-8";
export var blockIcon = "_hu-9";
export var blockTitle = "_hu-6";
export var border = "_hu-a";
export var center = "_hu-l";
export var edge = "_hu-b";
export var edgeLabel = "_hu-c";
export var edgePath = "_hu-d";
export var error = "_hu-e";
export var flowchart = "_hu-g";
export var flowchartContent = "_hu-h";
export var highlighted = "_hu-3";
export var hover = "_hu-4";
export var icon = "_hu-i";
export var left = "_hu-m";
export var navButton = "_hu-j";
export var navButtons = "_hu-k";
export var right = "_hu-n";
export var selected = "_hu-2";
export var small = "_hu-5";